import * as Models from 'models';

export const getFrozenEntityId = (state: Models.AppState.StateMap): string | null =>
  state.get('frozenEntityId');
